export default [
  {
    id: '1',
    nombre: 'POST_RECHAZO',
    descripcion: 'Posterior al rechazo del flujo',
    paso: 'Y'
  },
  {
    id: '2',
    nombre: 'POST_APROBADO',
    descripcion: 'Posteror a la aprobacion de flujo',
    paso: 'Y'
  },
  {
    id: '3',
    nombre: 'POST_PROCESO',
    descripcion: 'Posterior a un paso del flujo',
    paso: 'Y'
  },
  {
    id: '4',
    nombre: 'POST_INICIADO',
    descripcion: 'Al iniciar una ejecucion',
    paso: 'Y'
  },
  {
    id: '5',
    nombre: 'POST_DESESTIMADO',
    descripcion: 'Al desestimar una ejecucion',
    paso: 'N'
  }
];
